module.exports = __webpack_public_path__ + "static/media/hotelLoader.e526e84c.gif";